import { callGlobalFunction, readGlobal } from "./utils.js";

export const subscriptionsFeature = {
  get plans() {
    return readGlobal("SUBSCRIPTION_PLANS", null);
  },
  renderAdmin() {
    return callGlobalFunction("renderAdminSubscriptions");
  },
  approveProvider(providerId) {
    return callGlobalFunction("approveProvider", providerId);
  },
  rejectProvider(providerId) {
    return callGlobalFunction("rejectProvider", providerId);
  },
  renewProvider(providerId) {
    return callGlobalFunction("renewProvider", providerId);
  }
};
